import { eq } from '@tanstack/db'
import { useLiveQuery } from '@tanstack/react-db'
import { useLocalSearchParams, useRouter } from 'expo-router'
import { FlatList, StyleSheet } from 'react-native'
import { useCurrentOrg } from '@/hooks/useCurrentOrg'
import { useStore } from '@/lib/pocketbase'
import { useCollectionRefresh } from '@/ui/CollectionRefreshControl'
import { ConditionalList } from '@/ui/ConditionalList'
import { ListWrapper } from '@/ui/ListWrapper'
import { TagCard } from '@/ui/tags/TagCard'

export default function TagsPage() {
    const params = useLocalSearchParams<{ orgSlug: string }>()
    const router = useRouter()
    const { org: currentOrg, isLoading: isAuthLoading } = useCurrentOrg()
    const [tagsCollection] = useStore('tags')
    const { refreshControl } = useCollectionRefresh(['tags'])

    const { isLoading: isTagsLoading, data: tags = [] } = useLiveQuery(
        q =>
            q
                .from({ tags: tagsCollection })
                .where(({ tags }) => eq(tags.org, currentOrg.id))
                .orderBy(({ tags }) => tags.name, 'asc'),
        [currentOrg.id]
    )
    const isLoading = isAuthLoading || isTagsLoading
    const handleAddTag = () => {
        router.push(`/${params.orgSlug}/settings/tags/new`)
    }

    return (
        <ListWrapper>
            <ConditionalList
                data={tags}
                isLoading={isLoading}
                icon="tag"
                title="No tags yet"
                subtitle="Create your first tag to organize your content"
                buttonLabel="Add Tag"
                onButtonPress={handleAddTag}
            >
                <FlatList
                    data={tags}
                    keyExtractor={tag => tag.id}
                    renderItem={({ item }) => <TagCard tag={item} />}
                    contentContainerStyle={styles.container}
                    showsVerticalScrollIndicator={false}
                    refreshControl={refreshControl}
                />
            </ConditionalList>
        </ListWrapper>
    )
}

const styles = StyleSheet.create({
    container: {
        padding: 16,
        gap: 12,
    },
})
